import Script from 'next/script';
import React from 'react';

function Usercentrics() {
  const settingsId = process.env.NEXT_PUBLIC_USERCENTRICS_SETTINGS_ID;

  if (!settingsId) return null;

  return (
    <Script
      id='usercentrics-cmp'
      src='https://web.cmp.usercentrics.eu/ui/loader.js'
      data-settings-id={settingsId}
      strategy='afterInteractive'
    />
  );
}

export default Usercentrics;
